import {
  loyaltyPromotionAlwaysRecurringSchema,
  loyaltyPromotionMonthlyRecurringSchema,
  loyaltyPromotionNoneRecurringSchema,
  loyaltyPromotionSchema,
  loyaltyPromotionWeeklyRecurringSchema,
} from "@redotech/redo-model/loyalty/loyalty-definition";
import * as z from "zod/v4";

// Create input schema by omitting fields from each union member
const createLoyaltyPromotionInputSchema = z.discriminatedUnion(
  "recurringPattern",
  [
    loyaltyPromotionNoneRecurringSchema.omit({
      _id: true,
      team: true,
      createdAt: true,
      updatedAt: true,
    }),
    loyaltyPromotionAlwaysRecurringSchema.omit({
      _id: true,
      team: true,
      createdAt: true,
      updatedAt: true,
    }),
    loyaltyPromotionWeeklyRecurringSchema.omit({
      _id: true,
      team: true,
      createdAt: true,
      updatedAt: true,
    }),
    loyaltyPromotionMonthlyRecurringSchema.omit({
      _id: true,
      team: true,
      createdAt: true,
      updatedAt: true,
    }),
  ],
);

export const createLoyaltyPromotion = {
  name: "createLoyaltyPromotion" as const,
  input: createLoyaltyPromotionInputSchema,
  output: loyaltyPromotionSchema,
};
